let UPLOAD_VISA_OBJECT = {
   "thisVisa": "",
   "DOCUMENT_TYPE": "Visa_Passport_Proof",
   "visaUploaded": ""
};

export {UPLOAD_VISA_OBJECT};